<template>
    <div style="position: relative; overflow: hidden">
        <div class="row d-flex justify-end flex-row-reverse" v-if="patterns">
            <div class="col-md-2" v-for="pattern in patterns">
                <v-card @click="(selectedPattern != null) && (pattern.image !== selectedPattern.image)? $confirm('Changing pattern', $t('Are you sure? All data stored in this element will be removed.')).then(res => {selectPattern(pattern)}) : selectPattern(pattern)">
                    <v-img  style="border: 3px solid black;" v-if="pattern.image && selectedPattern && selectedPattern.image == pattern.image" height="150px" contain :src="getSrc(pattern.image)"></v-img>
                    <v-img  v-else-if="pattern.image" height="150px" contain :src="getSrc(pattern.image)"></v-img>
<!--                    <div v-else-if="pattern.file_name === 'custom'" style="height: 150px" class="d-flex justify-center align-content-center align-center flex-row">-->
<!--                        <p class="mb-0" style="text-align: center;">Custom content</p>-->
<!--                    </div>-->
                    <div v-else style="height: 150px" class="d-flex justify-center align-content-center align-center flex-row">
                        <p class="mb-0" style="text-align: center;">Products</p>
                    </div>
                </v-card>
            </div>
        </div>
        <div class="w-100 py-2 d-flex flex-column" v-if=" false && selectedPattern && selectedPattern.file_name !=='products'">
            <div class="d-flex justify-space-around flex-column" style="width: 100%;">
                <v-btn v-if="selectedPattern.file_name !== 'full-banner' && selectedPattern.file_name !== 'custom'" dark @click="useDefaultCssSettings" color="primary">{{ defaultCss && !(data.sectionHeight || data.mainHeaderFontSize || data.mainHeaderFontStyle || data.mainHeaderFontWeight || data.secondHeaderFontSize || data.secondHeaderFontStyle || data.secondHeaderFontWeight || data.paragraphHeaderFontSize || data.paragraphHeaderFontStyle || data.paragraphHeaderFontWeight) ? $t('Change default section settings'): $t('Use default section settings')}}</v-btn>
                <div class="pt-2" v-if="!defaultCss || data.sectionHeight || data.mainHeaderFontSize || data.mainHeaderFontStyle || data.mainHeaderFontWeight || data.secondHeaderFontSize || data.secondHeaderFontStyle || data.secondHeaderFontWeight || data.paragraphHeaderFontSize || data.paragraphHeaderFontStyle || data.paragraphHeaderFontWeight">
                    <div class="d-flex justify-space-around flex-column">
                        <div v-if="selectedPattern.file_name !== 'full-banner' &&  selectedPattern.file_name === 'section1-3'" class="d-flex flex-row pt-2">
                            <v-text-field
                                class="col-md-4"
                                label="Main header font size"
                                type="number"
                                min="1"
                                :rules="[validationRules.minVal(data.mainHeaderFontSize,1)]"
                                v-model="data.mainHeaderFontSize"
                                hide-details="auto"
                                suffix="pt"
                                outlined
                            ></v-text-field>
                            <v-select
                                class="col-md-4"
                                :items="fontStyle"
                                label="Font style"
                                v-model="data.mainHeaderFontStyle"
                                outlined
                            ></v-select>
                            <v-select
                                class="col-md-4"
                                :items="fontWeight"
                                label="Font weight"
                                v-model="data.mainHeaderFontWeight"
                                outlined
                            ></v-select>
                        </div>
                    </div>
                    <div v-if="selectedPattern.file_name !== 'section1-3' && selectedPattern.file_name !== 'full-banner'" class="d-flex flex-column">
                        <div class="d-flex flex-row pt-2">
                            <v-text-field
                                class="col-md-4"
                                label="Main header font size"
                                type="number"
                                min="1"
                                :rules="[validationRules.minVal(data.mainHeaderFontSize,1)]"
                                v-model="data.mainHeaderFontSize"
                                hide-details="auto"
                                suffix="pt"
                                outlined
                            ></v-text-field>
                            <v-select
                                class="col-md-4"
                                :items="fontStyle"
                                label="Font style"
                                v-model="data.mainHeaderFontStyle"
                                outlined
                            ></v-select>
                            <v-select
                                class="col-md-4"
                                :items="fontWeight"
                                label="Font weight"
                                v-model="data.mainHeaderFontWeight"
                                outlined
                            ></v-select>
                        </div>

                        <div class="d-flex flex-row">
                            <v-text-field
                                class="col-md-4"
                                label="Second header font size"
                                type="number"
                                min="1"
                                :rules="[validationRules.minVal(data.secondHeaderFontSize,1)]"
                                v-model="data.secondHeaderFontSize"
                                hide-details="auto"
                                suffix="pt"
                                outlined
                            ></v-text-field>
                            <v-select
                                class="col-md-4"
                                :items="fontStyle"
                                label="Font style"
                                v-model="data.secondHeaderFontStyle"
                                outlined
                            ></v-select>
                            <v-select
                                class="col-md-4"
                                :items="fontWeight"
                                label="Font weight"
                                v-model="data.secondHeaderFontWeight"
                                outlined
                            ></v-select>
                        </div>

                        <div class="d-flex flex-row">
                            <v-text-field
                                class="col-md-4"
                                label="Paragraph font size"
                                type="number"
                                min="1"
                                :rules="[validationRules.minVal(data.paragraphHeaderFontSize,1)]"
                                v-model="data.paragraphHeaderFontSize"
                                hide-details="auto"
                                suffix="pt"
                                outlined
                            ></v-text-field>
                            <v-select
                                class="col-md-4"
                                :items="fontStyle"
                                label="Font style"
                                v-model="data.paragraphHeaderFontStyle"
                                outlined
                            ></v-select>
                            <v-select
                                class="col-md-4"
                                :items="fontWeight"
                                label="Font weight"
                                v-model="data.paragraphHeaderFontWeight"
                                outlined
                            ></v-select>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2" v-else-if="(item && item.data && item.data.file_name === 'products') || item.type==='products'">
            <div class="row">
                <div class="col-md-4">
                    <v-text-field class="no-validation" v-if="!item.simpleSortProducts" placeholder="9" outlined label="Products per page" v-model="item.limit"></v-text-field>
                </div>
                <div v-if="item.row_limit && !item.simpleSortProducts" class="col-md-4">
                    <v-select :items="[1,2,3,4,6,12]" class="no-validation" @change="item.row_limit > 12 ? item.row_limit = 12 : null" outlined placeholder="3" label="Products per row"  v-model="item.row_limit"></v-select>
                </div>
                <div class="col-md-4">
                    <v-select v-if="!item.simpleSortProducts" class="no-validation" clearable v-model="item.sort_by" :items="['Newest','Oldest','Price ascending','Price descending', 'Name ascending', 'Name descending']" outlined :label="$t('Sort by')"></v-select>
                </div>

            </div>
            <div class="row">
                <div class="col-md-8">
                    <v-switch v-model="item.simpleSortProducts" item-value="name" :label="$t('Optional override to select & display specific products')"></v-switch>
                </div>
                <div v-if="item.row_limit && item.simpleSortProducts" class="col-md-4 d-flex justify-center align-center">
                    <v-select :items="[1,2,3,4,6,12]" class="no-validation" @change="item.row_limit > 12 ? item.row_limit = 12 : null" outlined placeholder="3" label="Products per row"  v-model="item.row_limit"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <v-btn class="small-btns" v-if="item.simpleSortProducts" @click="addSpecificProduct(item)" dark color="green">Add product</v-btn>
                </div>
            </div>
            <div v-if="item.simpleSortProducts && item.sort_products" class="row">
                <div class="col-md-6 d-flex flex-row justify-center align-center" style="position: relative;" v-for="(singleProduct, index) in item.sort_products">
                    <v-select v-model="item.sort_products[index]" :rules="[validationRules.required]" solo :items="productsToSort" ></v-select>
                    <v-btn style="width: 26px; height: 26px; top: 0; right: 0; position: absolute;" fab dark color="red" @click="item.sort_products.splice(index, 1);"><v-icon width="13px" height="13px" style="font-size: 13px;">mdi-trash-can</v-icon></v-btn>
                </div>
            </div>
        </div>
        <div :style="(item.data && !item.data.file_name) || (selectedPattern && selectedPattern.file_name && selectedPattern.file_name != 'products') ? 'display: block;' : 'display: none;'" class="mt-5 displayWholeWidth" :id="id">{{content}}</div>
        <input style="display: none;" name="image" type="file" id="upload" class="hidden" onchange="">
<!--        <div :id="id" v-if="selectedPattern && selectedPattern.html" v-html="selectedPattern.html"></div>-->
        <v-dialog @input="(!$event)? edited_id = null : null" :value="edited_id" :width="dialogWidth">
            <v-card v-if="edited_id">
                <v-card-title>
                    {{$t('Element basic info')}}
                </v-card-title>
                <v-card-text>
                    <v-text-field :label="$t('Redirect url')" v-model="data[edited_id].redirect_url" outlined dense></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" dark @click="edited_id = null">{{$t('Save and close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div v-if=" false && selectedPattern && selectedPattern.file_name !=='products'">
            <v-list>
                <v-list-item v-for="(item,index) in data" class="my-5">
                    <v-card-text v-if="getType(index) != 'IMG'">
                        <trumbowyg v-model="data[index].text" :config="{}" class="form-control" name="content"></trumbowyg>
                        <v-text-field v-model="data[index].text" class="validation-only"></v-text-field>
                    </v-card-text>
                    <v-file-input v-else @change="uploadFile(tmpMedia,'media',data[index])" v-model="tmpMedia" :clearable="false" accept="image/*" outlined :label="item.favicon ? $t('Replace image') : $t('Upload image')" class="mt-3"></v-file-input>
                    <v-btn @click="edited_id = index" style="top: 5px" fab x-small absolute color="secondary" right top dark><v-icon>mdi-pencil</v-icon></v-btn>
                </v-list-item>
            </v-list>
        </div>
    </div>
</template>
<style>
    .trumbowyg-box {
        min-height: 250px!important;
        height: 250px!important;
    }
    .trumbowyg-editor {
        min-height: 150px!important;
    }
</style>
<script>
    import {getAvailablePatterns} from "../api/websites";
    import {makeid} from "../helpers";
    import EditAddPrices from "@/views/products/edit-add-prices";
    import EditAddVariants from "@/views/products/edit-add-variants";
    import EditAddCategories from "@/views/products/edit-add-categories";
    import ProductPicker from "@/components/products-picker";
    import tinymce from 'tinymce/tinymce';
    import {upload} from "@/api/upload";

    const Trumbowyg = () => ({
        component: import('vue-trumbowyg'),
        timeout: 3000
    })
    export default {
        components:{Trumbowyg},
        props:['value', 'patterns_init', 'item','productsToSort'],
        data:() => {
            return{
                edited_id: null,
                id: null,
                showOptions:false,
                patterns:null,
                selectedPattern:null,
                data:{},
                defaultCss: true,
                tmpMedia: null,
                fontStyle: ['normal','italic'],
                fontWeight: ['normal','bold'],
                uploads: null,
                content: '',
                editor : null,
                cTinyMce : null,
                checkerTimeout: null,
                isTyping : false,
                other_options: { default : function() { return {}; }, type: Object},
                htmlClass : { default : '', type : String},
                plugins : [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime media nonbreaking save table contextmenu directionality',
                    'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample'
                ],
                toolbar1: 'fontselect fontsizeselect | formatselect | bold italic  strikethrough  forecolor backcolor | link |  image  | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | media | removeformat',
                // toolbar2: { default : '', type: String },
                image_title: true,
                font_formats:
                    "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                automatic_uploads: true,
                file_picker_types: 'image',
                file_picker_callback: function(callback, value, meta) {
                    if (meta.filetype == 'image') {
                        $('#upload').trigger('click');
                        $('#upload').on('change', function() {
                            var file = this.files[0];
                            var reader = new FileReader();
                            reader.onload = function(e) {
                                callback(e.target.result, {
                                    alt: ''
                                });
                            };
                            reader.readAsDataURL(file);
                        });
                    }
                },

            }
        },
        watch:{
            data:{
                deep: true,
                handler: function () {
                    this.updateView();
                    this.emitData();
                }
            },
        },
        beforeDestroy(from, to, next){
            if(this.editor){
                this.editor.destroy();
            }
        },
        created(){
            this.id = makeid(60);
        },
        mounted() {
            if(this.patterns_init){
                this.patterns = this.patterns_init;
                this.matchPattern();
            }else{
                this.getData();
                this.matchPattern();
            }


            this.init();

            if(!this.item.row_limit) this.item.row_limit = 3;
            if(!this.item.limit) this.item.limit = 9;
            if(!this.item.sort_by) this.item.sort_by = 'Newest';
        },
        methods:{
            init(){
                setTimeout(() => {
                    let options = {
                        selector: '#'+this.id,
                        skin: false,
                        toolbar1: this.toolbar1,
                        toolbar2: this.toolbar2,
                        plugins: this.plugins,
                        init_instance_callback : this.initEditor,
                        images_upload_credentials: true,
                        branding: false,
                        inline: true,
                        image_title: this.image_title,
                        automatic_uploads: false,
                        file_picker_types: 'image',
                        file_picker_callback: function(callback, value, meta) {
                            if (meta.filetype == 'image') {
                                $('#upload').trigger('click');
                                $('#upload').on('change', function() {
                                    var formData = new FormData();
                                    var file = this.files[0];
                                    formData.append("files[]", file, file.name);
                                    formData.append('path', '');
                                    this.uploading = true;
                                    upload(formData, 'tinymce').then(response => {
                                        this.uploading = false;
                                        callback(response.fullpath, {alt: 'Image'});
                                    }).catch(e => {
                                        this.uploading = false;
                                    })

                                });
                            }
                        },
                    };
                    tinymce.init(this.concatAssciativeArrays(options, this.other_options));
                },150);
                setTimeout(()=>{
                    if(this.item && this.item.full_html){
                        this.content = this.item.full_html.full_html;
                        this.$emit('input', this.item.full_html.full_html);
                        this.editor.setContent(this.item.full_html.full_html);
                    } else if(this.selectedPattern && this.selectedPattern.html){
                        this.content = this.selectedPattern.html;
                        this.$emit('input', this.selectedPattern.html);
                        this.editor.setContent(this.selectedPattern.html);
                    }
                },500);
            },
            initEditor(editor) {
                this.editor = editor;
                editor.on('KeyUp', (e) => {
                    this.submitNewContent();
                });
                editor.on('Change', (e) => {
                    if(this.editor.getContent() !== this.value){
                        this.submitNewContent();
                    }
                    this.$emit('editorChange', e);
                });
                editor.on('init', (e) => {
                    editor.setContent(this.content);
                    this.$emit('input', this.content);
                });
                if(this.readonly){
                    this.editor.setMode('readonly');
                } else {
                    this.editor.setMode('design');
                }
                this.$emit('editorInit', editor);
                tinymce.execCommand('mceFocus',false, this.id);
            },
            concatAssciativeArrays(array1, array2){
                if(array2.length === 0) return array1;
                if(array1.length === 0) return array2;
                let dest = [];
                for ( let key in array1) dest[key] = array1[key];
                for ( let key in array2) dest[key] = array2[key];
                return dest;
            },
            submitNewContent(){
                this.isTyping = true;
                if(this.checkerTimeout !== null)
                    clearTimeout(this.checkerTimeout);
                this.checkerTimeout = setTimeout(()=>{
                    this.isTyping = false;
                }, 300);
                this.$emit('input', this.editor.getContent());
            },
            getData(){
                getAvailablePatterns().then(res => {
                    this.patterns = res;
                })
            },
            matchPattern(){
                if(this.value && this.value.view){
                    var finded = this.patterns.find(x => x.file_name == this.value.view);
                    this.selectedPattern = finded;
                    setTimeout(() => {
                        this.data = this.value.data;
                        this.updateView();
                    },50)
                } else {
                    // this.selectPattern(this.patterns[4]);
                }
            },
            updateView(){
                if(this.data){
                    var root = $('#'+this.id);
                    for(var index in this.data){
                        var element = root.find('*[data-customize="'+index+'"]');
                        if(element.length > 0){
                            var type = element.prop('nodeName');
                            if(type == 'IMG'){
                                $(element).attr('src', this.getSrc(this.data[index].url));
                            }else{
                                $(element).html(this.data[index].text);
                            }
                        }
                    }
                }
            },
            selectPattern(pattern){
                if(pattern.file_name !=='products'){
                    this.data = {};
                    this.defaultCss=true;
                    this.selectedPattern = pattern;
                    this.initData(false);
                } else {
                    this.selectedPattern = pattern;
                    this.initData(true);
                }
                this.item.file_name = pattern.file_name;

                if(this.selectedPattern.html){
                    this.$emit('input', this.selectedPattern.html);
                    this.editor.setContent(this.selectedPattern.html);
                    let obj = {
                        full_html: this.selectedPattern.html,
                        type: this.selectedPattern.type,
                        file_name: this.selectedPattern.file_name
                    }
                    this.$set(this.data,'full_html', obj);
                }


            },
            emitData(isProduct){
                if(!isProduct){
                    this.$emit('input', {'type': 'custom', view: this.selectedPattern.file_name, data: this.data});
                } else {

                    this.$emit('input', {...this.selectedPattern, 'type': 'products'});
                }
            },
            getType(index){
                var element = $('#'+this.id).find('*[data-customize="'+index+'"]');
                if(element){
                    return element.prop('nodeName');
                }
                return null;
            },
            initData(isProduct){
                if(!isProduct){
                    setTimeout(() => {
                        var data = {};
                        $('#'+this.id).find('*[data-customize]').each((index,item) => {
                            this.$set(this.data, $(item).attr('data-customize'), {});
                            if($(item).attr('data-src')){
                                this.$set(this.data[$(item).attr('data-customize')], 'url', $(item).attr('data-src'));
                            }
                            if($(item).attr('data-text')){
                                this.$set(this.data[$(item).attr('data-customize')], 'text', $(item).attr('data-text'));
                            }
                        });
                        this.updateView();
                        this.emitData(isProduct);
                    }, 10)
                } else {
                    this.emitData(isProduct);
                }


               /* $('#pattern').find('*[data-custmize]').forEach(item => {
                    console.log('ITEM', item);
                })*/
            },
            useDefaultCssSettings(){
                this.defaultCss=!this.defaultCss;
                if(this.defaultCss){
                    this.$delete(this.data, 'sectionHeight');
                    this.$delete(this.data, 'mainHeaderFontSize');
                    this.$delete(this.data, 'mainHeaderFontStyle');
                    this.$delete(this.data, 'mainHeaderFontWeight');

                    this.$delete(this.data, 'secondHeaderFontSize');
                    this.$delete(this.data, 'secondHeaderFontStyle');
                    this.$delete(this.data, 'secondHeaderFontWeight');

                    this.$delete(this.data, 'paragraphHeaderFontSize');
                    this.$delete(this.data, 'paragraphHeaderFontStyle');
                    this.$delete(this.data, 'paragraphHeaderFontWeight');
                }
            },
            changeProductSortType(item){
                item.simpleSortProducts=!item.simpleSortProducts;
            },
            addSpecificProduct(item){
                item.sort_products ? item.sort_products.push(''): this.$set(item,'sort_products',['']);
            },
            uploadFile(file, path , originalValue){
                var formData = new FormData();
                formData.append("files[]", file, file.name);
                formData.append('path', '');
                this.uploading = true;
                upload(formData, path).then(response => {
                    this.uploading = false;
                    originalValue.url = response.data[0];
                }).catch(e => {
                    this.uploading = false;
                })
            }
        }
    }
</script>
<style>
.displayWholeWidth .container {
    max-width: 100%!important;
}
</style>
